import 'css-chunksrc/client/scenes/projectPortfolioCreation/form/colorPickerInput/styles.scss';export default {
  "colorPickerInput": "_colorPickerInput_1yc9g_1",
  "colorInput": "_colorInput_1yc9g_5",
  "color": "_color_1yc9g_1"
};